import React, { useCallback, useState } from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { useDispatch, useSelector } from 'react-redux';
import {
  createBrandAction,
  deleteBrandAction,
  editBrandAction
} from 'src/store/actions/catalogActions';
import { useTranslation } from 'react-i18next';
import {
  selectAuthDistributorId,
  selectAuthSystem
} from 'src/store/selectors/authSelectors';
import UserType from 'src/utils/constants/auth';
import Toolbar from '../Toolbar';
import BrandList from './BrandList';
import BrandForm from './BrandForm';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const BrandsListView = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const distributorId = useSelector(selectAuthDistributorId);
  const system = useSelector(selectAuthSystem);

  const handleClose = useCallback(() => {
    setOpen(false);
    setData(null);
  }, [setOpen, setData]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleOpenEdit = useCallback(
    values => {
      setOpen(true);
      setData(values);
    },
    [setOpen, setData]
  );

  const handleCreate = useCallback(
    values => {
      delete values.serviceId;
      dispatch(createBrandAction(values));
      handleClose();
    },
    [handleClose, dispatch]
  );

  const handleEdit = useCallback(
    values => {
      dispatch(editBrandAction(values));
      handleClose();
    },
    [handleClose, dispatch]
  );

  const handleDelete = useCallback(
    id => {
      dispatch(
        deleteBrandAction({
          id,
          distributorId:
            system === UserType.DISTRIBUTOR ? Number(distributorId) : null
        })
      );
      handleClose();
    },
    [handleClose, dispatch]
  );

  return (
    <Page className={classes.root} title={t('NAVIGATION.CATALOG_LIST.BRANDS')}>
      <Container maxWidth={false}>
        <Toolbar
          catalogLabel={t('NAVIGATION.CATALOG_LIST.BRANDS')}
          handleOpen={handleOpen}
        />
        <Box mt={3}>
          <BrandList
            handleOpenEdit={handleOpenEdit}
            handleDelete={handleDelete}
          />
        </Box>
      </Container>
      <BrandForm
        open={open}
        data={data}
        handleClose={handleClose}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
      />
    </Page>
  );
};

export default BrandsListView;
